<template>
    
  <div>

    <page-padding>

      <div v-if="!hasAlbums">{{$t('language.no_albums')}}</div>
    </page-padding>


   <infinite-list :key="updateKey" :list='albums[group_id+"album"]'>

        <template v-slot:default="album">
        <button-album :group_id="group_id" :key="album.item.id" :item_id="album.item.id" :image-url="album.item.thumb" :title="album.item.title"/>
          
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonAlbum from './ButtonAlbum.vue';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-albums',
  props:{
    group_id:{default:0},
    group_name:{default:undefined}
  },
  data:function(){
    return {
      showLoader:false,
      updateKey:0,
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonAlbum,
  },
  methods:{
    emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_albums(){
      this.emitLoadStart()
    
      this.$store.dispatch('get_albums',{store_key:this.group_id+"album", group_id:this.group_id, group_name:this.group_name}).then(()=>{
        this.updateKey=this.albums[this.group_id+"album"] ? this.albums[this.group_id+"album"].length : 0
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'albums',
       ]),
       hasAlbums:function(){
         if(this.albums[this.group_id+"album"]){
           return this.albums[this.group_id+"album"] ? this.albums[this.group_id+"album"].length : false
         }else{
           return false;
         }
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_albums)
  },
  mounted:function(){
    this.load_albums();
    eventBus.$on("RELOAD_FROM_PULL",this.load_albums)
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

